import requests from "./httpService";

const DepartmentServices = { 
  getAllDepartment: async () => {
    return requests.get("/department/all");
  }, 
 
  getDepartmentById: async (id) => {
    return requests.get(`/department/${id}`); 
  },

  addDepartment: async (body) => {
    return requests.post("/department/add", body);
  },

  updateDepartment: async (id, body) => {
    return requests.put(`/department/${id}`, body);
  }, 

  deleteDepartment: async (id, body) => {
    return requests.delete(`/department/${id}`, body);
  },  

};

export default DepartmentServices; 
